import { createAction } from '../../util/';
import { getUserAccount, getUserData } from '../../user/selectors';

export const addToast = createAction('ADD_TOAST');
export const clearToast = createAction('CLEAR_TOAST', { noPayload: true });

export const showToast = (data, duration) => (dispatch, getState) => {
  const state = getState();
  const userAccount = getUserAccount(state) || {};
  const userData = getUserData(state) || {};
  const timeout = duration || (userAccount?.number ? 3000 : 1500);

  dispatch(addToast(data));
  if (data.type !== 'error') {
    setTimeout(() => {
      dispatch(clearToast());
    }, timeout);
  } else if (data.error) {
    window.newrelic?.noticeError(data.error, { handled: true, userId: userData?.id });
  }
};
